import { constants } from 'src/app/config/constants';
import { Sortable } from './sortable';

export class PageReq {
  url: string;
  private _page: number;
  private _size: number;
  sorts: Array<Sortable>;

  constructor(url?: string, page?: number, size?: number, sorts?: Array<Sortable>) {
    this.url = url;
    this._page = page === undefined ? 1 : page;
    this._size = size === undefined ? constants.rowsPerPage : size;
    this.sorts = sorts;
  }

  get page(): number {
    return this._page;
  }

  set page(value: number) {
    this._page = value ? value : 1;
  }

  get size(): number {
    return this._size;
  }

  set size(value: number) {
    this._size = value ? value : constants.rowsPerPage;
  }

  /**
   * URL Pattern: http://domain/api?size=10&page=0&sort=user,asc&sort=age,desc
   * @return string
   */
  toUrl(): string {
    let paging = this.url + '?'
      + 'size=' + this._size + '&'
      + 'page=' + this._page + '&'
      + this.generateSort();

    paging = paging.slice(0, paging.length);
    return paging;
  }

  /**
   * return example { page: 1, size: 10, sort: column,desc }
   * @return object
   */
  toParams(params?: { [key: string]: any }): { [key: string]: any } {
    if (params == null || typeof params === 'undefined') {
      params = {};
    }
    params.page = this._page;
    params.size = this._size;
    params.sort = this.sorts;
    return params;
  }

  private generateSort(): string {
    let paging = '';

    if (this.sorts) {
      this.sorts.forEach((sort, index) => {
        paging += 'sort=' + sort.field;
        if (sort.type) {
          paging += ',' + sort.type;
        }
        paging += '&';
      });
    }
    return paging;
  }
}
